const formatStringToNumber = (formattedString) => {
    if(!formattedString || formattedString === '') {
        console.err('Erro ao formatar preço do produto para valor numérico:', formattedString);
        return 0;
    }
    
    // Remove thousands separators
    let withoutThousandSeparator = formattedString.replace(/\./g, '');

    // Replace comma with a dot
    let withDot = withoutThousandSeparator.replace(',', '.');

    // Convert to float
    return parseFloat(withDot);
};

const gtmProductNormalizer = props => {
    // Destructured props
    const {data} = props;
    
    let dataLayerProducts = [];

    data.forEach(value => {
        dataLayerProducts.push({
            "name": value?.name,
            "id": value?.productId,
            "category": value?.category,
            "price": formatStringToNumber(value?.price),
            "quantity": 1,
        });
    });

    return dataLayerProducts;
}

export default gtmProductNormalizer;
